define.alias("shared/helpers/is-active", "settings/helpers/is-active");